'use client';

import type { Content, GroupField } from '@prismicio/client';
import { useEffect, useState } from 'react';
import type { Simplify } from '../../../../../../prismicio-types';
import Card from './Card';
import styles from './loanUsesCards.module.scss';

interface LoanUsesCardsProps {
  cards: GroupField<Simplify<Content.LoanUsesSliceDefaultPrimaryCardsItem>>;
  isVisible: boolean;
}

const animationPaths = [
  '/static/animations/loan-uses/card-1.json',
  null,
  '/static/animations/loan-uses/card-3.json',
  '/static/animations/loan-uses/card-4.json',
];

const fetchAnimation = async (path: string) => {
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error(`Failed to fetch animation: ${path}`);
  }
  return response.json();
};

export const LoanUsesCards = ({ cards, isVisible }: LoanUsesCardsProps) => {
  const [videoList, setVideoList] = useState<object[]>([]);
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const fetchedVideos = await Promise.all(
          animationPaths.map((path) => (path ? fetchAnimation(path) : null))
        );
        setVideoList(fetchedVideos);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching animations:', error);
      }
    };

    fetchVideos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animationPaths]);

  return (
    <ul className={styles.list}>
      {cards.map((item, index) => (
        <Card
          item={item}
          index={index}
          isVisible={isVisible}
          key={index}
          animation={videoList[index]}
        />
      ))}
    </ul>
  );
};
